import { useTranslation } from 'next-i18next';
import React, { ReactElement } from 'react';
import {
  FdrImage,
  FdrProductB2bInformationGroup,
} from '@hotelplan/supergraph-api';
import { FdrB2bAdditionalInfo } from 'components/domain/fdr-b2b-additional-info';
import { FdrHotelMap } from 'components/domain/fdr-hotel-map';
import { FdrHotelMediaGallery } from './fdr-pdp.styles';

const INITIAL_SLIDE_INDEX = 1; // We should start from the second slide, cause first is used as hero;

interface IFdrHotelContentProps {
  images: Array<FdrImage>;
  b2bInfoGroups: Array<FdrProductB2bInformationGroup>;
}

export function FdrHotelContent({
  images,
  b2bInfoGroups,
}: IFdrHotelContentProps): ReactElement {
  const [t] = useTranslation('pdp');

  return (
    <>
      {images?.length ? (
        <FdrHotelMediaGallery
          title={t('pdp:hotel.mediaGallery.title')}
          initialSlide={INITIAL_SLIDE_INDEX}
          mediaItems={images}
        />
      ) : null}
      <FdrHotelMap />
      {b2bInfoGroups?.length ? (
        <FdrB2bAdditionalInfo b2bInfoGroups={b2bInfoGroups} />
      ) : null}
    </>
  );
}
